export function _debounce(func, delay) {
  let timerId
  return function (...args) {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function _throttle(callback, delay) {
  let previousCall = new Date().getTime()
  return function () {
    const time = new Date().getTime()

    // 如果距离上一次函数调用的时间已经超过给定的时间量delay，那么执行函数回调
    if (time - previousCall >= delay) {
      previousCall = time
      callback.apply(this, arguments)
    }
  }
}

export function _updatePages(url) {
  let WxPages = decodeURIComponent(url.split('=')[1])
  window.WxPages = WxPages
}

export function _getPathParam(url) {
  const decodedInstance = decodeURIComponent(url.split('=')[1])
  // 拿到小程序页面栈数量
  let WxPages = decodeURIComponent(url.split('=')[2])
  window.WxPages = WxPages
  // 拿到小程序传参
  // console.log('🌏 => 图片路径', url)
  return decodedInstance.split('&')[0]
}

export function _returnParam(url) {
  const decodedInstance = decodeURIComponent(url)
  const paramsStr = decodedInstance.split('?')[1]
  const paramsArr = paramsStr.split('&')

  const params = {}
  params.materialId = paramsArr[0].split('=')[1]
  params.imgPath = paramsArr[1].split('=')[1]
  params.pas = paramsArr[2].split('=')[1]
  params.WxPages = paramsArr[3].split('=')[1]

  return params
}
